import React, { memo } from 'react'
import './index.scss'
import { useTranslation } from 'react-i18next'
import { getAppDisplayName } from '@/utils/appBrand'

interface RuleProps {
    activityThresholdValue: number
}

function index(props: RuleProps) {
    const { t } = useTranslation()
    return (
        <div className='cmp-rule'>
            {new Array(3).fill(0).map((_, i) =>
                <span key={i}>{t(`WeekStar.Rule.Rule${i}`, { APP: getAppDisplayName(), num: props.activityThresholdValue })}</span>
            )}
        </div>
    )
}

export default memo(index)